module.exports = __webpack_public_path__ + "img/calendar.3d7c5b3e.png";